import React from 'react'
import CustomerManagementPage from './customer-management-page'

const CustomerSalesView = () => {
	return <CustomerManagementPage salesView={true} />
}

export default CustomerSalesView
